import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as GraphdataActions from 'actions/graphdata';
import classNames from 'classnames';
import {
  SELECTION_INTRADAY,
  SELECTION_WEEK,
  SELECTION_HISTORIC,
} from 'constants/Graphdata';

import { componentId } from './OverviewChart';
import 'components/PeriodSelector/PeriodSelector.scss';

class PeriodSelector extends Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    const actions = bindActionCreators(GraphdataActions, dispatch);
    this.actions = actions;

    this.setSelection = this.setSelection.bind(this);
  }

  setSelection(period) {
    this.actions.setSelection(componentId, period);
  }

  render() {
    const { selection } = this.props;
    return (
      <div className="PeriodSelector">
        <button
          className={classNames({ selected: selection === SELECTION_INTRADAY })}
          onClick={() => this.setSelection(SELECTION_INTRADAY)}
        >
          Intradag
        </button>
        <button
          className={classNames({ selected: selection === SELECTION_WEEK })}
          onClick={() => this.setSelection(SELECTION_WEEK)}
        >
          Uke
        </button>
        <button
          className={classNames({ selected: selection === SELECTION_HISTORIC })}
          onClick={() => this.setSelection(SELECTION_HISTORIC)}
        >
          Historisk
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selection: state.graphdata.getIn([componentId, 'selection']),
  };
}

export default connect(mapStateToProps)(PeriodSelector);
